var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade-transition"}},[(_vm.modalOverlayVisibility)?_c('div',{staticClass:"modal-overlay",on:{"click":function($event){$event.stopPropagation();return _vm.setModalOverlayVisibility(false)}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }